import { OrchestrationSlotsResponse } from "../types/orchestration";
import httpService from "./httpService";

/**
 * Read-only client for the admin Performance Orchestration Status endpoint (PWA-2150).
 * Mirrors the `/v3/admin/...` pattern used by appSettingsService.
 *
 * Backend: GET /v3/admin/performance-orchestration/slots?limit=N
 *   - admin-only (JWT + ADMIN role)
 *   - limit defaults to 10, clamped to [1, 50] server-side
 *   - returns { items: [...] } newest first
 */
class OrchestrationService {
  private readonly baseUrl = "/v3/admin/performance-orchestration";

  async getSlots(limit = 10): Promise<OrchestrationSlotsResponse> {
    const response = await httpService.get<OrchestrationSlotsResponse>(
      `${this.baseUrl}/slots?limit=${encodeURIComponent(limit)}`
    );
    return response.data;
  }
}

export const orchestrationService = new OrchestrationService();
export default orchestrationService;
